import { render, staticRenderFns } from "./eod-measurement-list-user.vue?vue&type=template&id=889985e8"
import script from "./eod-measurement-list-user.vue?vue&type=script&lang=js"
export * from "./eod-measurement-list-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports